import { GetterTree } from 'vuex';
import { HistoryState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { QueryHistoryGetter } from './getters/query-history.getter';

export const HISTORY_GETTERS: GetterTree<HistoryState, RootStoreState> = {
  ...new QueryHistoryGetter().getters
};
